const $ = jQuery.noConflict();

'use strict';
const Accordion = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	$domAccordionTrigger: $('.js-accordion__item-sign'),
	$domAccordionItem: $('.js-accordion__item'),
	$domAccordionImageBox: $('.accordion__item-image-box'),

	accordionActive: 'accordion-active',

	/** @description Initialize */
	init: function() {
		this.accordionLogic();
		this.appendAccordion();
	},

	accordionLogic: function() {
		Accordion.$domAccordionTrigger.on('click', function() {
			if(!$(this).parent().parent().hasClass(Accordion.accordionActive)) {
				Accordion.$domAccordionItem.removeClass(Accordion.accordionActive);
				Accordion.$domAccordionItem.find('.js-accordion__item-hidden').stop().slideUp();
				$(this).parent().parent().addClass(Accordion.accordionActive);
				$(this).parent('.js-accordion__item-visible').next().stop().slideDown();

				const dataAttributeItem = $(this).parent().parent().attr('data-atr');

				Accordion.$domAccordionImageBox.removeClass(Accordion.accordionActive);
				$(`[data-img="${dataAttributeItem}"]`).addClass(Accordion.accordionActive);
			}else {
				if($(window).width() < 992) {
					$(this).parent().parent().removeClass(Accordion.accordionActive);
					$(this).parent('.js-accordion__item-visible').next().stop().slideUp();
				}
			}
		});

		if($(window).width() < 992) {
			$('[data-atr="1"] .js-accordion__item-hidden').stop().slideDown();
			$('[data-atr="1"]').addClass(Accordion.accordionActive);
		}
	},

	appendAccordion: function() {
		if($(window).width() < 992) {
			$('[data-img]').each(function() {
				const item = $(this).data('img');
				$(this).prependTo('[data-atr="' + item + '"] .js-accordion__item-hidden');
			});
		}
	}
};

export default Accordion;
